// src/services/api.js
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://apiocm.mtrsistemas.com.br',
});

// Interceptor para adicionar o token às requisições
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// --- Transações ---
export const getTransactions = () => api.post('/transacoes/listar');
export const getTransactionById = (id) => api.post('/transacoes/buscarid', { id });
export const addTransaction = (data) => api.post('/transacoes/cadastrar', data);
export const updateTransaction = (id, data) => api.post('/transacoes/atualizar', { id, ...data });
export const deleteTransaction = (id) => api.post('/transacoes/apagar', { id });
export const getMonthlyTransactions = (year, monthNum) => api.post('/transacoes/listarmes', { ano: year, mes: monthNum });
export const getMonthlyTotal = (year, month) => api.post('/transacoes/somarmes', { ano: year, mes: month });
export const getPaymentMethodsTotal = (year, month) => api.post('/transacoes/somarporpagamento', { ano: year, mes: month });
export const getDailyTransactions = (date) => api.post('/transacoes/listardia', { data: date });
export const getDailyTotal = (date) => api.post('/transacoes/somaodia', { data: date });

// --- Usuários ---
export const getUsers = () => api.post('/usuarios/listar');
export const getUserByEmail = (email) => api.post('/usuarios/buscarperfil', email);
export const createUser = (data) => api.post('/usuarios/cadastrar', data);
export const updateUser = (id, data) => api.patch(`/usuarios/atualizar`, data);
export const deleteUser = (id) => api.post('/usuarios/apagar', { id });

// --- NOVO: Preferências do Sistema ---
export const getAppPreferences = () => api.post('/preferences/get'); // Use POST se o seu backend assim espera, ou GET se mudar lá
export const saveAppPreferences = (preferencesData) => api.post('/preferences/save', preferencesData);
export const uploadAppLogo = (file) => {
    const formData = new FormData();
    formData.append('logoFile', file); // 'logoFile' deve corresponder ao nome do campo no multer (upload.single('logoFile'))
    return api.post('/preferences/upload-logo', formData, {
        headers: {
            'Content-Type': 'multipart/form-data' // Essencial para uploads de arquivo
        }
    });
};

export default api;